<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'>
        <el-form-item label='角色名称：'>
          <el-input v-model='searchForm.roleNm' size='mini' placeholder='请输入角色名称' />
        </el-form-item>
        <el-form-item label='状态：'>
          <el-select v-model='searchForm.isEnable' filterable size='mini' placeholder='请选择'>
            <el-option v-for='item in isEnableOption' :key='item.label' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
      </el-form>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <div class='content'>
      <el-table
        v-loading='tableLoad'
        :data='tableData'
        style='width: 100%'
        border
        stripe
        row-key='id'
        :header-cell-style='headerCellStyle'
        :cell-style='cellStyle'>
        <el-table-column label='序号' align='center' width='50px' type='index' />
        <el-table-column label='角色名称' prop='roleNm' align='center' min-width='250' />
        <el-table-column label='备注' prop='description' align='center' min-width='200' />
        <el-table-column label='添加时间' prop='createTime' align='center' min-width='200'>
          <div slot-scope='scope'>{{ scope.row.createTime|timeFormat }}</div>
        </el-table-column>
        <el-table-column label='状态' align='center' width='100'>
          <div slot-scope='scope'>{{ scope.row.isEnable|isEnableFormat }}</div>
        </el-table-column>
        <el-table-column label='操作' align='center' min-width='300'>
          <template slot-scope='scope'>
            <el-button v-if='scope.row.isEnable' size='mini' type='danger'
                       @click='enableOrDisable(scope.row.id,"disable")'>禁用
            </el-button>
            <el-button v-else size='mini' type='primary'
                       @click='enableOrDisable(scope.row.id,"enable")'>启用
            </el-button>
            <el-button size='mini' type='primary' @click='changeClick(scope.row)' class='yellow-bg'>
              修改
            </el-button>
            <el-button size='mini' type='primary' @click='setClick(scope.row)' class='resetBtn'>
              权限设置
            </el-button>
            <el-button size='mini' type='danger' class='delete' @click='deleteClick(scope.row.id)'>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>

    <!-- 新增/修改 -->
    <role-new ref='roleNewRef' @success='getList' />
    <!-- 权限设置 -->
    <role-permission-settings ref='rolePermissionSettingRef' @success='getList' />
  </div>
</template>

<script>
  import { removeSpace, formatDateTime } from '@/config/mUtils';
  import {
    loadMenuGetRolePage,
    addRoleEmp,
    isEnableRole,
    isDeleteRole,
    updateMenuByRole,
    updateRole,
    getMenuByRoleId,
    seAllMenu,
  } from '@/service/basicfile';
  import RoleNew from '@/views/basicfile/system/role-components/role-new';
  import RolePermissionSettings
    from '@/views/basicfile/system/role-components/role-permission-settings';

  export default {
    components: {
      RolePermissionSettings,
      RoleNew,
    },
    data() {
      return {
        defaultSearchForm: {},
        searchForm: {
          roleNm: '',
          isEnable: '',
          rows: 10,
          page: 1,
        },
        isEnableOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '启动中',
          },
          {
            value: 0,
            label: '禁用中',
          },
        ],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        cellStyle: {
          'color': '#7F7F7F',
          'font-size': '13px',
          'height': '52px',
        },
        tableLoad: false,
        tableData: [],
        total: 0,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.getList();
    },
    filters: {
      timeFormat(val) {
        return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
      },
      isEnableFormat(val) {
        switch (val) {
          case 1:
            return '启用中';
          case 0:
            return '禁用中';
        }
      },
    },
    methods: {
      async getList() {
        this.tableLoad = true;
        const res = await loadMenuGetRolePage(this.searchForm);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableData = res.data.records;
        this.total = res.data.totalRows;
      },
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      searchBtn() {
        this.searchForm.page = 1;
        this.getList();
      },
      addBtn() {
        this.$refs.roleNewRef.dialogOpen('新增角色');
      },
      changeClick(item) {
        this.$refs.roleNewRef.dialogOpen('修改角色', item);
      },
      // 权限设置
      setClick(item) {
        this.$refs.rolePermissionSettingRef.dialogOpen(item);
      },
      // 改变当前页数据条数
      contractSizeChange(sizes) {
        this.searchForm.rows = sizes;
        this.getList();
      },
      // 切换当前页
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getList();
      },
      enableOrDisable(id, flag) {
        this.$confirm(flag === 'disable' ? '确定要禁用当前角色吗？' : '确定要启用当前角色吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isEnableRole(id);
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            await this.getList();
          })
          .catch(() => {
          });
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确定要删除当前角色吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isDeleteRole(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this.getList();
          })
          .catch(() => {
          });
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
